// extracted by mini-css-extract-plugin
module.exports = {"inputFilter":"AccountingVoucherTable_inputFilter__2LBIq","containerTable":"AccountingVoucherTable_containerTable__25v8j"};